import { forwardRef } from "react";
import "./AnimSection.css";

const AnimSectionTemplate = forwardRef(({ children, visible, delay, className }, ref) => {
  return (
    <div
      ref={ref}
      className={`anim-section ${visible ? "anim-section--visible" : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
});

AnimSectionTemplate.displayName = "AnimSectionTemplate";
export default AnimSectionTemplate;
